module.exports = function() {
  return new Worker(__webpack_public_path__ + "42ed433379d4a9a7e195.worker.js");
};